module.exports = __webpack_public_path__ + "img/687-e2cef7.png";